import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem } from 'reactstrap';
import { animateScroll as scroll, Link } from 'react-scroll';

import * as _ from 'lodash';

import './navigation.scss';

interface NavigationComponentProps {
  companyName: string;
}

class NavigationComponent extends Component<NavigationComponentProps, any> {

  state: any = {
    collapsed: true
  };

  private scrollOptions: any;

  constructor(props: any) {
    super(props);
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);

    this.scrollOptions = {
      activeClass: 'active',
      href: '#',
      spy: true,
      hashSpy: false,
      smooth: true,
      offset: (window.screen.width < 768) ? -56 : -74,
      duration: 500,
      className: 'nav-link',
      onClick: this.toggleNavbar,
    };
  }

  toggleNavbar() {
    this.setState({collapsed: !this.state.collapsed});
  }

  scrollToTop(event: any) {
    event.preventDefault();
    scroll.scrollToTop(this.scrollOptions);
  }

  render() {
    return (
        <Navbar dark={true} expand="md" fixed="top" role="navigation">
          <NavbarBrand href="#" className="mr-auto" onClick={this.scrollToTop}>{this.props.companyName}</NavbarBrand>
          <NavbarToggler onClick={this.toggleNavbar} className="mr-2"/>
          <Collapse isOpen={!this.state.collapsed} navbar={true}>
            <Nav navbar={true} className="ml-auto">
              <NavItem>
                <Link {...this.scrollOptions} to="expertise">Expertise</Link>
              </NavItem>
              <NavItem>
                <Link {...this.scrollOptions} to="skills">Skills</Link>
              </NavItem>
              <NavItem>
                <Link {...this.scrollOptions} to="references">References</Link>
              </NavItem>
              <NavItem>
                <Link {...this.scrollOptions} to="experience">Experience</Link>
              </NavItem>
              <NavItem>
                <Link {...this.scrollOptions} to="contact" offset={0}>Contact</Link>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
    );
  }
}

const mapStateToProps = (state: any): NavigationComponentProps => {
  return {
    companyName: _.get(state, 'cv.basics.company', '')
  };
};

export default connect(mapStateToProps, null)(NavigationComponent);



// WEBPACK FOOTER //
// ./src/components/navigation/navigation.component.tsx